import React, { useState, useEffect } from 'react'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'
import MultipleChoiceText from '../InteractionComponents/MultipleChoiceText'
import MultipleChoiceImage from '../InteractionComponents/MultipleChoiceImage'
import MultipleAnswerText from '../InteractionComponents/MultipleAnswerText'
import MultipleAnswerImage from '../InteractionComponents/MultipleAnswerImage'
import TrueFalseSingleComponent from '../InteractionComponents/TrueFalseSingleComponent'
import TrueFalseChoiceComponent from '../InteractionComponents/TrueFalseChoiceComponent'
import SliderStaticComponent from '../InteractionComponents/SliderStaticComponent'
import DragAndDropMCQ from '../InteractionComponents/DragAndDropMCQ'
import SliderDynamicComponent from '../InteractionComponents/SliderDynamicComponent'
import NumberPickerComponent from '../InteractionComponents/NumberPickerComponent'
import TypeAnswerComponent from '../InteractionComponents/TypeAnswerComponent'
import FillTheBlankText from '../InteractionComponents/FillTheBlankText'
import InlineChoiceText from '../InteractionComponents/InlineChoiceText'
import FillInHighlight from '../InteractionComponents/FillInHighlight'
import HotspotComponent from '../InteractionComponents/HotspotComponent'
import MatchTableComponent from '../InteractionComponents/MatchTableComponent'
import FractionComponent from '../InteractionComponents/FractionComponent'
import ArrangeParagraphComponent from '../InteractionComponents/ArrangeParagraphComponent'
import RankList from '../InteractionComponents/RankList'
import DynamicCategorize from '../InteractionComponents/DynamicCategorize'
import CategorizeComponent from '../InteractionComponents/CategorizeComponent'
import MatchingExercise from '../InteractionComponents/MatchingExercise'
import ImageSlideComponent from '../NonInteractionComponents/ImageSlideComponent'
import AudioSlideComponent from '../NonInteractionComponents/AudioSlideComponent'
import VideoSlideComponent from '../NonInteractionComponents/VideoSlideComponent'
import PdfSlideComponent from '../NonInteractionComponents/PdfSlideComponent'
import ThreeDSlideComponent from '../NonInteractionComponents/ThreeDSlideComponent'
import RotateDynamicComponent from '../InteractionComponents/RotateDynamicComponent'
import RotateStaticComponent from '../InteractionComponents/RotateStaticComponent'
import H5PComponents from '../H5PComponents/H5PComponents'
import IFrameComponent from '../NonInteractionComponents/iFrameComponent'

function SmartSlideBaseScreen(props) {
  //Values from client
  const {
    user,
    initial,
    Completed,
    smartSlideData,
    isPractice,
    isActive,
    isVerifyMode,
    explanationClick,
    screenMode,
    timerEnd,
    controlsList,
    audioStop,
    showCountTime,
    isResetClick,
    hotspotSkipTracker,
    isTtsPlay,
    isBgAudioPlayed,
    canvasAreaDimensions
  } = props

  //Values to client
  const {
    setExplanationText,
    setExplanationStatus,
    setExplanationVisible,
    setExplanationClick,
    handleSuccessModal,
    handleValueChange,
    handleAttemptsChange,
    onVideoPlaying
  } = props

  const {
    ControlID,
    QuestionText,
    QuestionType,
    Description,
    AnswerType,
    Options,
    Answers,
    Score,
    Background,
    AnswerColorFill,
    QuestionColorFill,
    QuestionFontSize,
    AnswerFontSize,
    SelectionColor,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    SequenceHint,
    QuestionHeight,
    Opacity,
    Priority,
    TextAlign,
    FontStyle,
    Italic,
    Bold
  } = smartSlideData

  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  //Get answer explanation from component
  function handleExplanationChange(explanationStatus, explanationString) {
    if (explanationString && explanationString !== '') {
      setExplanationText(explanationString)
      setExplanationStatus(explanationStatus)
      setExplanationVisible(true)
    } else {
      setExplanationClick(false)
      setExplanationVisible(false)
    }
  }

  //Display right or wrong feedback
  function handleSuccessChange(successValue) {
    if (isPractice) {
      handleSuccessModal(successValue)
    }
  }

  function renderSlideComponent() {
    if (
      smartSlideData.PluginName === 'SSMultipleChoice' &&
      ((smartSlideData.DisplayType === 'radioButton' &&
        (smartSlideData.AnswerType === 'text' ||
          smartSlideData.AnswerType === 'inktotext')) ||
        smartSlideData.DisplayType === 'chatBubbles')
    ) {
      return (
        <MultipleChoiceText
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          isVerifyMode={isVerifyMode}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleChoice' &&
      smartSlideData.DisplayType === 'radioButton' &&
      (smartSlideData.AnswerType === 'image' ||
        smartSlideData.AnswerType === 'ink')
    ) {
      return (
        <MultipleChoiceImage
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          isVerifyMode={isVerifyMode}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleChoice' &&
      smartSlideData.DisplayType === 'Drag and Drop'
    ) {
      return (
        <DragAndDropMCQ
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={
            controlsList.length > 0
              ? controlsList.find((cl) => cl.CtlId === smartSlideData.ControlID)
              : undefined
          }
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleChoice' &&
      smartSlideData.DisplayType === 'rangeSlideStatic'
    ) {
      return (
        <SliderStaticComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleChoice' &&
      smartSlideData.DisplayType === 'rotatingDialStatic'
    ) {
      return (
        <RotateStaticComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleAnswer' &&
      ((smartSlideData.DisplayType === 'checkbox' &&
        (smartSlideData.AnswerType === 'text' ||
          smartSlideData.AnswerType === 'inktotext')) ||
        smartSlideData.DisplayType === 'chatBubbles')
    ) {
      return (
        <MultipleAnswerText
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          isVerifyMode={isVerifyMode}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSMultipleAnswer' &&
      smartSlideData.DisplayType === 'checkbox' &&
      (smartSlideData.AnswerType === 'image' ||
        smartSlideData.AnswerType === 'ink')
    ) {
      return (
        <MultipleAnswerImage
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          isVerifyMode={isVerifyMode}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSTrueFalse' &&
      (smartSlideData.DisplayType === 'choiceMatrix' ||
        smartSlideData.DisplayType === 'single')
    ) {
      return (
        <TrueFalseChoiceComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          isResetClick={isResetClick}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSRotatingDial' &&
      smartSlideData.DisplayType === 'slider'
    ) {
      return (
        <SliderDynamicComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSRotatingDial' &&
      smartSlideData.DisplayType === 'RotatingDial'
    ) {
      return (
        <RotateDynamicComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSRotatingDial' &&
      smartSlideData.DisplayType === 'TypeAnswer'
    ) {
      return (
        <TypeAnswerComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          isResetClick={isResetClick}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSRotatingDial' &&
      smartSlideData.DisplayType === 'numberPicker'
    ) {
      return (
        <NumberPickerComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSArrange' &&
      smartSlideData.DisplayType === 'paragraph'
    ) {
      return (
        <ArrangeParagraphComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={
            controlsList.length > 0 &&
            controlsList.find((cl) => cl.CtlId === smartSlideData.ControlID)
          }
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      smartSlideData.PluginName === 'SSArrange' &&
      smartSlideData.DisplayType === 'list'
    ) {
      return (
        <RankList
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      isBgAudioPlayed &&
      smartSlideData.PluginName === 'SSFillinTheBlanks' &&
      smartSlideData.DisplayType === 'type'
    ) {
      return (
        <FillTheBlankText
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          isResetClick={isResetClick}
          initial={initial}
        />
      )
    } else if (
      isBgAudioPlayed &&
      smartSlideData.PluginName === 'SSFillinTheBlanks' &&
      smartSlideData.DisplayType === 'inlineChoice'
    ) {
      return (
        <InlineChoiceText
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          isResetClick={isResetClick}
        />
      )
    } else if (
      isBgAudioPlayed &&
      smartSlideData.PluginName === 'SSFillinTheBlanks' &&
      smartSlideData.DisplayType === 'highlight'
    ) {
      return (
        <FillInHighlight
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (smartSlideData.PluginName === 'Hotspot') {
      return (
        <HotspotComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          hotspotSkipTracker={hotspotSkipTracker}
        />
      )
    } else if (smartSlideData.PluginName === 'DynamicCategory') {
      return (
        <DynamicCategorize
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
          isResetClick={isResetClick}
        />
      )
    } else if (smartSlideData.PluginName === 'SSCategory') {
      return (
        <CategorizeComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          isVerifyMode={isVerifyMode}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          timerEnd={timerEnd}
        />
      )
    } else if (
      isBgAudioPlayed &&
      smartSlideData.PluginName === 'SSMatchParent'
    ) {
      return (
        <MatchingExercise
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={
            controlsList.length > 0 &&
            controlsList.find((cl) => cl.CtlId === smartSlideData.ControlID)
          }
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          isVerifyMode={isVerifyMode}
          timerEnd={timerEnd}
          showCountTime={showCountTime}
          canvasAreaDimensions={canvasAreaDimensions}
          isBgAudioPlayed={isBgAudioPlayed}
        />
      )
    } else if (smartSlideData.PluginName === 'HotspotImages') {
      return (
        <ImageSlideComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          timerEnd={timerEnd}
          onValueChange={handleValueChange}
        />
      )
    } else if (smartSlideData.PluginName === 'EnrichedPlayer') {
      return (
        <VideoSlideComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          timerEnd={timerEnd}
          onValueChange={handleValueChange}
          isTtsPlay={false}
          isBgAudioPlayed={isBgAudioPlayed}
          onVideoPlaying={(videoStatus) => {
            setIsVideoPlaying(videoStatus)
            onVideoPlaying(videoStatus)
          }}
        />
      )
    } else if (smartSlideData.PluginName === 'EnrichedPDF') {
      return (
        <PdfSlideComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          timerEnd={timerEnd}
          onValueChange={handleValueChange}
        />
      )
    } else if (smartSlideData.PluginName === 'EnrichedAudio') {
      return (
        <AudioSlideComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          audioStop={audioStop}
          timerEnd={timerEnd}
          onValueChange={handleValueChange}
          isTtsPlay={false}
          isBgAudioPlayed={isBgAudioPlayed}
        />
      )
    } else if (smartSlideData.PluginId === 'Visor3D') {
      return (
        <ThreeDSlideComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          screenMode={screenMode}
        />
      )
    } else if (smartSlideData.PluginName === 'MatchTable') {
      return (
        <MatchTableComponent
          mcData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          isVerifyMode={isVerifyMode}
          timerEnd={timerEnd}
          showCountTime={showCountTime}
          //handleSucAndFailFeedback={handleSucAndFailFeedback}
        />
      )
    } else if (smartSlideData.PluginName === 'Fraction') {
      return (
        <FractionComponent
          fractionData={smartSlideData}
          key={smartSlideData.ControlID}
          isPractice={isPractice}
          completed={Completed}
          isActive={isActive}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
          defaultValue={controlsList.find(
            (cl) => cl.CtlId === smartSlideData.ControlID
          )}
          explanationClick={explanationClick && explanationClick}
          onExplanationVisible={handleExplanationChange}
          screenMode={screenMode}
          handleSuccessChange={handleSuccessChange}
          isVerifyMode={isVerifyMode}
          timerEnd={timerEnd}
          showCountTime={showCountTime}
          //handleSucAndFailFeedback={handleSucAndFailFeedback}
        />
      )
    } else if (smartSlideData.PluginName === 'H5P') {
      return (
        <H5PComponents
          mcData={smartSlideData}
          userId={user.LoginID}
          initial={initial}
          isEmbeded={false}
          onAttemptChange={handleAttemptsChange}
          onValueChange={handleValueChange}
        />
      )
    } else if (smartSlideData.PluginName === 'Webpage') {
      return <IFrameComponent iFrameData={smartSlideData} isEmbeded={false} />
    }
  }

  return (
    <div
      className='slide-main-cont'
      style={{
        pointerEvents: isBgAudioPlayed
          ? smartSlideData &&
            smartSlideData.PluginName &&
            (smartSlideData.PluginName === 'EnrichedPlayer' ||
              smartSlideData.PluginName === 'EnrichedPDF' ||
              smartSlideData.PluginName === 'EnrichedAudio' ||
              smartSlideData.PluginId === 'Visor3D')
            ? 'auto'
            : Completed === 1 || !isActive
            ? 'none'
            : 'auto'
          : 'none',
        backgroundImage:
          smartSlideData.PluginName === 'DynamicCategory' ||
          smartSlideData.PluginName === 'Hotspot'
            ? ''
            : `url(${Background})`,
        backgroundColor:
          smartSlideData.PluginName === 'DynamicCategory' ||
          smartSlideData.PluginName === 'Hotspot'
            ? ''
            : Background !== ''
            ? Background
            : '#dc8c82'
      }}
    >
      <div
        className='slide-opac-cont'
        style={{
          backgroundColor:
            smartSlideData.PluginName === 'DynamicCategory' ||
            smartSlideData.PluginName === 'Hotspot'
              ? ''
              : Opacity
        }}
      >
        <div
          className={
            smartSlideData.PluginName === 'DynamicCategory'
              ? 'slide-canvas-cont slide-width-100'
              : 'slide-canvas-cont slide-width-80'
          }
          style={{ zIndex: isVideoPlaying ? 9 : undefined }}
        >
          {smartSlideData.PluginName !== 'HotspotImages' &&
            smartSlideData.PluginName !== 'EnrichedPlayer' &&
            smartSlideData.PluginName !== 'EnrichedPDF' &&
            smartSlideData.PluginName !== 'EnrichedAudio' &&
            smartSlideData.PluginName !== 'Visor3D' &&
            smartSlideData.PluginName !== 'DynamicCategory' &&
            smartSlideData.PluginName !== 'Hotspot' && (
              <SlideQuestion
                QuestionText={
                  smartSlideData.PluginName === 'SSMatchParent' ||
                  smartSlideData.PluginName === 'SSCategory'
                    ? Description
                    : QuestionText
                }
                QuestionType={
                  smartSlideData.PluginName === 'SSMatchParent' ||
                  smartSlideData.PluginName === 'SSCategory'
                    ? 'text'
                    : QuestionType
                }
                Description={Description}
                QuestionColorFill={QuestionColorFill}
                QuestionFillColor={QuestionFillColor}
                QuestionFontSize={QuestionFontSize}
                QuestionFontFamily={FontStyle}
                QuestionFontWeight={Bold}
                QuestionFontStyle={Italic}
              />
            )}
          <div
            className='smartslide-answer-container'
            style={{
              height:
                smartSlideData.PluginName !== 'HotspotImages' ||
                smartSlideData.PluginName !== 'EnrichedPlayer' ||
                smartSlideData.PluginName !== 'EnrichedPDF' ||
                smartSlideData.PluginName !== 'EnrichedAudio' ||
                smartSlideData.PluginName !== 'Visor3D' ||
                smartSlideData.PluginName === 'DynamicCategory'
                  ? '100%'
                  : '84%'
            }}
          >
            <div
              className='smartslide-answer-main-container'
              style={{
                justifyContent:
                  smartSlideData.PluginName === 'HotspotImages' ||
                  smartSlideData.PluginName === 'EnrichedPlayer' ||
                  smartSlideData.PluginName === 'EnrichedPDF' ||
                  smartSlideData.PluginName === 'EnrichedAudio' ||
                  smartSlideData.PluginName === 'Visor3D'
                    ? 'center'
                    : 'normal'
              }}
            >
              {renderSlideComponent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { SmartSlideBaseScreen }
